export const formatDateToDDMMYYYY = (dateString: string | undefined): string => {
  if (!dateString) {
    return '';
  }
  const parts = dateString.split('T')[0].split('-');
  if (parts.length === 3) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return dateString;
};


export const formatDateTime = (date:any)=> {
    // Helper function to pad single-digit numbers with a leading zero
    const pad = (num:any) => String(num).padStart(2, '0');

    // --- Date Components (DD/MM/YYYY) ---
    // Note: getMonth() returns 0 for January, 1 for February, etc., so we add 1.
    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1);
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;

    // --- Time Components (HH:MM:SS) ---
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    const formattedTime = `${hours}:${minutes}:${seconds}`;

    // Combine date and time
    return `${formattedDate}, ${formattedTime}`;
}